
import { CargoScanFailed } from "@/domain/entities/Cargo";
import { prop, Vue } from "vue-class-component";
import XLSX from "xlsx";

export class Props {
  data = prop<CargoScanFailed[]>({
    default: () => [],
    required: true,
    type: Array
  });
  title = prop<string>({
    default: "Daftar STT/Bag gagal scan",
    type: String
  });
  dataDirection = prop<string>({
    default: "justify-between items-center",
    type: String
  });
  isDispatch = prop<boolean>({
    default: false,
    type: Boolean
  });
}

export default class ScanFailedCard extends Vue.with(Props) {
  XLSX = XLSX;
  downloadExcel() {
    let data: any[];

    if (this.isDispatch) {
      // Header dispatch
      data = this.data.map((d) => ({
        "Nomor DEM": d.demNo ?? "",
        "Nomor STT": d.sttNumber,
        "Status Terakhir STT": d.lastStatus,
        "Alasan Gagal": d.failureReason
      }));
    } else {
      // Header lama
      data = this.data.map((d) => ({
        "Nomor STT/Bag": d.sttNumber,
        "Status Terakhir STT/Bag": d.lastStatus,
        "Alasan Gagal": d.failureReason
      }));
    }

    const sheet = this.XLSX.utils.json_to_sheet(data);
    const wb = this.XLSX.utils.book_new();
    this.XLSX.utils.book_append_sheet(wb, sheet, "STT gagal scan");
    this.XLSX.writeFile(wb, "STT gagal scan.xlsx");
  }
}
